export default {
    cz: {
        placeholder: 'Zadejte název produktu nebo vybavení k půjčení',
        search: 'Hledat',
    },
    sk: {
        placeholder: 'Zadajte názov produktu alebo vybavenia na požičanie',
        search: 'Hľadať',
    },
}
